import React from "react"

export default function OptOut({ accountName, redactedEmailAddress, token }) {
  const csrfToken = document.querySelector("meta[name=csrf-token]").content

  return (
    <div className="mx-auto my-12" style={{ maxWidth: 652 }}>
      <div className="p-10 bg-white text-gray-800 rounded-lg shadow-md">
        <h1 className="text-2xl text-gray-900 font-semibold">
          {accountName || "Opt-out from preference-based advertising"}
        </h1>

        {redactedEmailAddress != undefined && (
          <p className="text-gray-900 text-base mt-6 mb-5">
            Are you sure you want to opt out {redactedEmailAddress} from
            preference-based advertising?
          </p>
        )}

        <p className="text-gray-900 text-base mb-5">
          Preference-based advertising may be used in our emails. With
          preference-based advertising, you see ads that are relevant to you. If
          you no longer wish to receive preference-based advertising, you can
          opt-out by clicking on the button below. If you opt-out you will still
          see ads, but they will not be personalized or behaviorally targeted
          ads.
        </p>

        <OptOutForm csrfToken={csrfToken} token={token} />
      </div>
    </div>
  )
}

const OptOutForm = ({ csrfToken, token }) => {
  return (
    <form action={`/opt-out/${token}`} method="post">
      <input
        type="hidden"
        name="authenticity_token"
        value={csrfToken}
        readOnly={true}
      />
      <button
        className="mt-6 inline-flex items-center border border-transparent no-underline leading-5 focus:outline-none bg-gray-900 text-sm text-white font-semibold hover:bg-red-600 focus:bg-red-600 focus:outline-blue py-3 px-5 rounded"
        type="submit"
      >
        Opt-out from preference-based advertising
      </button>
    </form>
  )
}
